import React from 'react';

import { ComponentStageType } from '../../types';

import { FullHeightContainer } from '../Containers';
import { Header } from '../Header';
import { Button } from '../Button';
import { ButtonBar } from '../ButtonBar';
import { AppHeader } from '../AppHeader';

import {
    createEnterExitAnimation,
    createFadeInOutAnimation,
} from '../../transitions';
import { animationDelay } from '../../constants';
import { createMarkup } from '../../utils';
import { SubHeader } from '../SubHeader';

interface IProps {
    stepNumber: number;
    animationUrl?: string;
    headerText: string;
    subHeaderText?: string;
    tooltipText?: string;
    componentStage: ComponentStageType;
    totalSteps: number;
    onAnimationExit(): void;
    onNextButtonClick(): void;
    onBackButtonClick?(): void;
    onCloseButtonClick?(): void;
}

export const IntroView: React.FC<IProps> = ({
    stepNumber,
    headerText,
    subHeaderText,
    componentStage,
    totalSteps,
    onAnimationExit,
    onNextButtonClick,
    onBackButtonClick,
    onCloseButtonClick,
}) => {
    const secondAnimation = createEnterExitAnimation({
        stage: componentStage,
        delay: animationDelay.second,
    });

    const fourthAnimation = createFadeInOutAnimation({
        stage: componentStage,
        delay: animationDelay.fourth,
        onRest: onAnimationExit,
    });

    return (
        <>
            <AppHeader
                totalSteps={totalSteps}
                stepNumber={stepNumber}
                onBackButtonClick={onBackButtonClick}
                onCloseButtonClick={onCloseButtonClick}
            />
            <FullHeightContainer>
                <Header
                    style={secondAnimation}
                    dangerouslySetInnerHTML={createMarkup(headerText)}
                />
                {subHeaderText && (
                    <SubHeader
                        style={secondAnimation}
                        dangerouslySetInnerHTML={createMarkup(subHeaderText)}
                    />
                )}
            </FullHeightContainer>
            <ButtonBar>
                <Button style={fourthAnimation} onClick={onNextButtonClick}>
                    begin
                </Button>
            </ButtonBar>
        </>
    );
};
